import { createContext, useContext } from "react";

export type InnerCrudContextValue = Record<string, any>;

export const InnerCrudContext = createContext<InnerCrudContextValue | boolean>(
  false
);

export function useInnerCrudContext() {
  return useContext(InnerCrudContext);
}
